import { CardMedia } from '@mui/material';
import organizationChart from 'assets/images/OrganizationChart.png';
import React from 'react';

export const OrganizationChart = () => {
  return (
    <>
      <CardMedia
        component="img"
        height={700}
        sx={{ padding: '1em 1em 0 1em', objectFit: 'contain' }}
        image={organizationChart}
        alt="Estructura de la Alianza"
      />
    </>
  );
};
